import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, effect, inject, input, output, untracked} from '@angular/core';
import { FieldTextComponent, FieldNumberComponent, FieldSelectComponent, AbstractFormArrayComponent } from '@spike/scaffolds';
import { Button } from "primeng/button";
import { TableModule } from "primeng/table";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrganizationListComponent } from "../../../organizations/components/organization-list/organization-list";
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { startWith, switchMap } from 'rxjs';
import { OrganizationStoreService } from '../../../organizations/services/organization-store.service';
import { EntityApiEnum, EtiquetteApiEnum, ModelApiEnum } from 'src/app/config/entity-api.enum';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-position-operations-form',
  providers:[],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, Button, TableModule, CommonModule, FormsModule, FieldTextComponent, FieldNumberComponent, FieldSelectComponent, OrganizationListComponent],
  templateUrl: './position-operations-form.html'
})

export class PositionOperationsFormComponent extends AbstractFormArrayComponent{
  public readonly organizationStore = inject(OrganizationStoreService);
  private readonly cdr = inject(ChangeDetectorRef);

  isConsuntivo=input.required<boolean>();
  workingPhase=input.required<number>();
  addExternalRow = output<void>();
  addInternalRow = output<void>();
  deleteRow = output<number>();
  calculateInternalTotal = output<number>();
  calculateExternalTotal = output<number>();
  
  machineApi= EntityApiEnum.MACHINE;
  employeeApi= EntityApiEnum.EMPLOYEE;
  //supplierApi= EntityApiEnum.SUPPLIER;
  operationApi= EntityApiEnum.OPERATION;
  machineEtiquetteApi= EtiquetteApiEnum.MACHINE;  
  employeeEtiquetteApi= EtiquetteApiEnum.EMPLOYEE;  
  //supplierEtiquetteApi= EtiquetteApiEnum.SUPPLIER;  
  operationEtiquetteApi= EtiquetteApiEnum.OPERATION;  
  machineModelApi = ModelApiEnum.MACHINE;
  employeeModelApi = ModelApiEnum.EMPLOYEE;
  //supplierModelApi = ModelApiEnum.SUPPLIER;
  operationModelApi = ModelApiEnum.OPERATION;

  showCost=computed(()=>{
    const workingPhase =this.workingPhase();
    return workingPhase==1;
  });
 
  isProduction=computed(()=>{
    const workingPhase =this.workingPhase();
    return workingPhase==3;
  });
 

  showState=computed(()=>{
    const workingPhase =this.workingPhase();
    return workingPhase==3;
  });

  private readonly formValues = toSignal(
    toObservable(this.form).pipe(
      switchMap(array => array.valueChanges.pipe(
        startWith(array.getRawValue())
      ))
    )
  );

  
  isExternal(rowGroup:any){
    return rowGroup.get('workType').value==2
  }
  isInternal(rowGroup:any){
    return rowGroup.get('workType').value==1
  }


  constructor() {
    super();
   
    effect(() => {
      const currentValues = this.formValues();
      const isEditing = !this.isFormDisabled();
      const isConsuntivo = this.isConsuntivo();
      const isProduction = this.isProduction(); 

     

      if (isEditing && currentValues) {
        let internalTotal = 0;
        let externalTotal = 0;
        this.form().controls.forEach((control, index) => {
          const row = currentValues[index];

          if (!row) return;
          const costControl = control.get('operationTypeId');
          const machine = control.get('machineId');
          const employee = control.get('employeeId');

          if(!costControl?.value && (machine?.value || employee?.value)) {
            machine?.patchValue(null, { emitEvent: false });
            employee?.patchValue(null, { emitEvent: false });
            return;
          }


          let rowCost = 0;
          if (isProduction) {
            const costControl = control.get('cost');
            const finalCostControl = control.get('finalCost');
            const machineCost = this.organizationStore.getMachine(row.machineId)()?.cost ?? 0;
            const employeeCost = this.organizationStore.getEmployee(row.employeeId)()?.cost ?? 0;
            const wt = isConsuntivo ? row.finalWorkingTime ?? 0 : row.workingTime ?? 0;
            const et = isConsuntivo ? row.finalEquipmentTime ?? 0 : row.equipmentTime ?? 0;

            rowCost = ((((machineCost + employeeCost)/60) * (wt))* row.quantity ) + (employeeCost* (et/60));
            rowCost = parseFloat(rowCost.toFixed(2));
            internalTotal += rowCost;

            if (isConsuntivo && finalCostControl) {
              finalCostControl.patchValue(rowCost, { emitEvent: false });
            }else if(!isConsuntivo && costControl){
              costControl.patchValue(rowCost, { emitEvent: false });
            } 
          } else{
            const costControl = control.get('cost');
            const finalCostControl = control.get('finalCost');
            const operationCost = this.organizationStore.getOperation(row.operationTypeId)()?.cost ?? 0;
            const wt = row.workingTime ?? 0;
            const et = row.equipmentTime ?? 0;
            rowCost = ((((operationCost)/60) * (wt))* row.quantity );
            rowCost = parseFloat(rowCost.toFixed(2));
            internalTotal += rowCost;
            if(!isConsuntivo && costControl){
              costControl.patchValue(rowCost, { emitEvent: false });
            } 


          }

          
        });

        untracked(() => {
          this.calculateInternalTotal.emit(internalTotal);
          this.calculateExternalTotal.emit(externalTotal);
        });
      } else{
        untracked(() => {
          this.cdr.markForCheck();
        });
      }
    });
  }
}

